/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  // Check if printer has been set or not
  if (localStorage.getItem("printer") == "" || localStorage.getItem("printer") == undefined || localStorage.getItem("printer") == null) localStorage.setItem("printer", 0); // Check if printer has been set or not

  if (localStorage.getItem("paperSize") == "" || localStorage.getItem("paperSize") == undefined || localStorage.getItem("paperSize") == null) localStorage.setItem("paperSize", 0);

  var printButton = function printButton() {
    printPurchase();
  };

  var printMyText = function printMyText() {
    var data = window.kiosk;
    var printText = "";
    var print80Line = "";
    if (localStorage.getItem("paperSize") == 1) print80Line = "______________";
    printText += "{BR}{H}TEST RECEIPT{/H}{BR}{BR}";
    printText += "Order ID:123456789{BR}";
    printText += print80Line + "_______________________________";
    window.DatecsPrinter.printText(printText + "{BR}{BR}", 'ISO-8859-1');
    window.DatecsPrinter.printText("Please fill in customer detail", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}{BR}Name  :_____________________", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}IC    :_____________________", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}Phone :_____________________", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}Sign  :_____________________", 'ISO-8859-1');
    window.DatecsPrinter.printText("{BR}{BR}{CENTER}", 'ISO-8859-1');
    printMyBarcode("123456789");
  };

  var printMyImage = function printMyImage() {
    var image = new Image();
    image.src = 'static/images/gd.jpg';

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.height = 100;
      canvas.width = 100;
      var context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);
      var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

      window.DatecsPrinter.printImage(imageData, //base64
      canvas.width, canvas.height, 1, function () {
        printMyQR();
      });
    };
  };

  var printMyQR = function printMyQR() {
    var qrcodejs = new QRCode("qrcode", {
      text: "123456789",
      width: 150,
      height: 150,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H
    });

    var imageData = qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg").replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

    console.log(qrcodejs._oDrawing._elCanvas.toDataURL("image/jpeg"));
    window.DatecsPrinter.printImage(imageData, //base64
    150, 150, 1, function () {
      printMyText();
    });
  };

  var printMyBarcode = function printMyBarcode(text) {
    var canvas = document.createElement("canvas");
    canvas.height = 400;
    canvas.width = 300;
    JsBarcode(canvas, text, {
      format: "CODE128"
    });
    var imageData = canvas.toDataURL('image/jpeg').replace(/^data:image\/(png|jpg|jpeg);base64,/, ""); //remove mimetype

    window.DatecsPrinter.printImage(imageData, //base64
    canvas.width, canvas.height, 1, function () {
      window.DatecsPrinter.printText("{BR}{BR}{BR}{BR}{CENTER}", 'ISO-8859-1');
      window.DatecsPrinter.writeHex('1B69');
      window.DatecsPrinter.getStatus(); //THIS TO OPEN THE DRAWER
    });
  };

  var printPurchase = function printPurchase() {
    if (!window.DatecsPrinter) {
      alert("DatecsPrinter plugin is missing. Have you installed the plugin? \nRun 'cordova plugin add cordova-plugin-datecs-printer'");
    } else {
      window.bluetooth = localStorage.getItem("printer");
      if (window.bluetooth == null || window.bluetooth == undefined) window.bluetooth = 0;
      window.DatecsPrinter.listBluetoothDevices(function (devices) {
        window.DatecsPrinter.connect(devices[window.bluetooth].address, function () {
          printMyImage();
        }, function () {
          $f7.dialog.alert("Error connecting to device");
          alert(JSON.stringify(error));
        });
      }, function (error) {
        $f7.dialog.alert("Error, no device");
        alert(JSON.stringify(error));
      });
    }
  };

  $on('pageInit', function () {});
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="kiosk_receipt">
  <div class="page-content">
    <!-- <div class="block-title block-title-large">Receipt</div> -->
    <div class="printtext">

    </div>
    <div class="block">
      <div style="text-align: center;">
        <img id="barcode"/>

        <img src='static/images/printer.png' width="300px"/>
        <br/>
        
        <p>
          Press the button to test print, cut, and open cash drawer
        </p>
        <p>
          <button class="button button-fill" @click=${printButton}>TEST PRINT</button>
        </p>
      </div>
      
      <p style="text-align: center;">
        <!-- <button class="button-fill" @click=${printPurchase} style="font-size:30px;width: 500px; height: 300;">PRINT RECEIPT</button> -->
      </p>
      <div id="qrcode" style="display:none;"></div>
      <div class="block">
        <div style="text-align: center;">
          <img id="barcode"/>
        </div>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '9b781a87fe';
export default framework7Component;